<h1>Layer position</h1>
<canvas #canvasDocument class="canvas"></canvas>
<div>{{ fps }}</div>
